import { ReportVideoModal } from '@vimeo/clip-ui/components/ReportVideoModal';

export interface ReportVideoProps {
  clipId: string;
  isOpen: boolean;
  onClose: () => void;
}

export const ReportVideoModalModule = ({ clipId, isOpen, onClose }: ReportVideoProps) => {
  const onSubmitReport = () => {
    // I added this here because the ReportVideoModal requires onSubmitReport to be passed in
    // This also acts as a placeholder for BP events
    console.log('Report submitted');
  };

  return (
    <ReportVideoModal
      clipId={clipId}
      isOpen={isOpen}
      onClose={onClose}
      onSubmitReport={onSubmitReport}
    />
  );
};
